import React from 'react';
import ButtonComp from 'atoms/Buttons/Presentation/ButtonComp';
import { useSelector } from 'react-redux';

const QuantityModifier = props => {
  const {
    itemQuantity,
    itemCount,
    updateItemQuantity,
    quantityAction,
    item,
    itemName,
    cartItemCount,
    maxItemCountPerLineItem,
    hideChild = false,
    type = '',
  } = props;
  var dname = `Decreases quantity by 1 item for ${itemName}`;
  var iname = `Increases quantity by 1 item for ${itemName}`;
  const isUpdateQuantityLoading = useSelector(data => data.cartReducer?.isUpdateQuantityLoading);
  return (
    <div className='cart-food-quantity-change'>
      {itemCount === itemQuantity ? (
        <ButtonComp className='button quantity-decrease' disabled data-testid='quantity-minus' ariaLable='minus'>
          {!hideChild && <span>-</span>}
        </ButtonComp>
      ) : (
        <ButtonComp
          className='button quantity-decrease'
          ariaLable={dname}
          disabled={isUpdateQuantityLoading}
          onClickHandler={event => updateItemQuantity(item, quantityAction.Decrease, event)}
          data-testid='quantity-minus'
          type={type}
        >
          {!hideChild && <span>-</span>}
        </ButtonComp>
      )}
      <span className='cart-food-quantity'>{itemCount}</span>
      <span className='sr-only' role='alert'>{`Quantity updated to ${itemCount}`}</span>
      <ButtonComp
        className='.transparent-btn button quantity-increase'
        ariaLable={iname}
        data-testid='quantity-plus'
        type={type}
        onClickHandler={event => updateItemQuantity(item, quantityAction.Increase, event)}
        disabled={
          maxItemCountPerLineItem !== 0 && cartItemCount + itemCount > maxItemCountPerLineItem
            ? true
            : false || isUpdateQuantityLoading
        }
      >
        {!hideChild && <span>+</span>}
      </ButtonComp>
    </div>
  );
};
export default QuantityModifier;
